/**
 * Acces au compte, en haut a droite des ecrans hors partie.
 *
 * Discret et toujours a la meme place : l'accueil, le salon et l'arrivee dans
 * une partie sont les trois moments ou l'on a le temps de s'occuper de son
 * compte. Pendant une manche, il n'a rien a faire la.
 *
 * Connecte, il montre l'avatar choisi et mene au profil ; anonyme, il mene a la
 * creation de compte. Un seul bouton, deux destinations, parce que c'est la
 * meme intention : « mon compte ».
 */
import type { ReactElement } from 'react';
import { useT } from '../locales/useT.js';
import { navigate } from '../router.js';
import { useAccountStore } from '../account/accountStore.js';
import { useUiStore } from '../store/uiStore.js';
import { Avatar } from './Avatar.js';
import { UserIcon } from './icons.js';

export function AccountButton(): ReactElement {
  const t = useT();
  const profile = useAccountStore((state) => state.profile);
  const avatar = useUiStore((state) => state.avatar);
  return (
    <button
      type="button"
      className="account-button"
      aria-label={t('account.button')}
      title={t('account.button')}
      onClick={() => navigate('/account')}
    >
      {avatar === null ? (
        <UserIcon />
      ) : (
        <Avatar playerId={profile?.id ?? 'me'} colorIndex={0} size={28} avatar={avatar} />
      )}
    </button>
  );
}
